// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAtRDZycvV5F02JeTCOKl2gF_r6FKOVPIk",
    authDomain: "pizzatoons-fb6b6.firebaseapp.com",
    projectId: "pizzatoons-fb6b6",
    storageBucket: "pizzatoons-fb6b6.firebasestorage.app",
    messagingSenderId: "264251179317",
    appId: "1:264251179317:web:8038c1bf0464b8d91c0c7c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
